import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import React from 'react';
import { Button } from '../../../../catalyst/core';

const FormFooter = ({ submitText, removeSubmit, isSubmitting }) => {
    return (
        <Grid container spacing={3} justifyContent="flex-end">
            <Grid row="true" item>
                {!removeSubmit ? (
                    <>
                        <Button
                            variant="contained"
                            color="primary"
                            loading={isSubmitting}
                            type="submit"
                        >
                            {submitText}
                        </Button>
                    </>
                ) : null}
            </Grid>
        </Grid>
    );
};
export default FormFooter;

FormFooter.propTypes = {
    removeSubmit: PropTypes.bool,
    submitText: PropTypes.string,
};

FormFooter.defaultProps = {
    removeSubmit: false,
    submitText: 'Submit',
};
